
/**
 * @export
 * @enum {string}
 */
export enum CrmIdType {
    SFDC = 'SFDC',
    MS_DYNAMICS = 'MS_DYNAMICS',
    HUBSPOT = 'HUBSPOT',
    EXTERNAL_CRM = 'EXTERNAL_CRM',
    DEAL_CLOUD = 'DEAL_CLOUD'
}